import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  tabs: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
    borderBottom: `1px solid ${theme.border.outline}`,
    padding: '0.5rem',

    '& > $tab:not(:last-child)': {
      marginRight: '0.5rem'
    }
  },

  tab: {
    border: '1px solid transparent',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '0.5rem',
    cursor: 'pointer',
    transition: 'all 200ms',

    '&:hover': {
      background: 'rgba(0, 0, 0, 0.1)'
    }
  },

  tabSelected: {
    border: `1px solid ${theme.border.outline}`
  }
}))

export default useStyles
